import Vue from 'vue';
import VueRouter from 'vue-router';

import {
  getCookie
} from '@/utils/getToken.js';

Vue.use(VueRouter);

const routes = [
  //易名start
  //icp/edi
  {
    path: '/ymicpdemand',
    name: 'ymicpdemand',
    component: () => import('../views/yiming/icpedi/demand')
  },


  //易名end

  // 广播电视
  {
    path: '/radiodemand',
    name: 'radiodemand',
    component: () => import('../views/radio/demand')
  },

  // 文网文
  {
    path: '/wwwdemand',
    name: 'wwwdemand',
    component: () => import('../views/wenwangwen/demand')
  },
  // 工商
  {
    path: '/gongshangdemand',
    name: 'gongshangemand',
    component: () => import('../views/gongshang/demand')
  },
  //////////////////////////////////////下面是icp --- 已上线 --- 放在/views/icplicense/的文件夹里面
  {
    path: '/icpdemand',
    name: 'icpdemand',
    component: () => import('@/views/icplicense/demand'),
  },
  {
    path: '/icporderdetail',
    name: 'icporderdetail',
    component: () => import('@/views/icplicense/orderdetail'),
  },
  {
    path: '/icpmyorder',
    name: 'icpmyorder',
    component: () => import('@/views/icplicense/myorder'),
    children: [{
      path: '/icpmyorder',
      redirect: '/icpmyorder/purchased',
    },
    {
      path: 'tobepaid',
      name: 'tobepaid',
      component: () => import('@/views/icplicense/myorder/tobepaid.vue'),
    },
    {
      path: 'purchased',
      name: 'purchased',
      component: () => import('@/views/icplicense/myorder/purchased.vue'),
    },
    ],
  },
  //启服通icp
  {
    path: '/icpfillmaterials',
    name: 'icpfillmaterials',
    component: () => import('@/views/icplicense/fillmaterials'),
    children: [{
      path: '/icpfillmaterials',
      redirect: '/icpfillmaterials/applicantInfo',
    },
    {
      path: 'applicantInfo',
      name: 'applicantInfo',
      component: () =>
        import('@/views/icplicense/fillmaterials/applicantInfo.vue'),
    },
    {
      path: 'implementation',
      name: 'implementation',
      component: () =>
        import('@/views/icplicense/fillmaterials/implementation.vue'),
    },
    {
      path: 'personnel',
      name: 'personnel',
      component: () =>
        import('@/views/icplicense/fillmaterials/personnel.vue'),
    },
    {
      path: 'shareholder',
      name: 'shareholder',
      component: () =>
        import('@/views/icplicense/fillmaterials/shareholder.vue'),
    },
    {
      path: 'materials',
      name: 'materials',
      component: () =>
        import('@/views/icplicense/fillmaterials/materials.vue'),
    },
    ],
  },
  //阿里icp对接
  {
    path: '/alicpfillmaterials',
    name: 'alicpfillmaterials',
    component: () => import('@/views/icplicense/alfillmaterials'),
    children: [{
      path: '/alicpfillmaterials',
      redirect: '/alicpfillmaterials/applicantInfo',
    },
    //基本信息
    {
      path: 'applicantInfo',
      name: 'applicantInfo',
      component: () =>
        import('@/views/icplicense/alfillmaterials/applicantInfo.vue'),
    },
    //企业人员情况
    {
      path: 'personnel',
      name: 'personnel',
      component: () =>
        import('@/views/icplicense/alfillmaterials/personnel.vue'),
    },
    {
      path: 'implementation',
      name: 'implementation',
      component: () =>
        import('@/views/icplicense/alfillmaterials/implementation.vue'),
    },
    {
      path: 'submitsuccess',
      name: 'submitsuccess',
      component: () =>
        import('@/views/icplicense/alfillmaterials/submitSuccess.vue'),
    },
    ],
  },
  {
    path: '/icpmaterialdetails',
    name: 'icpmaterialdetails',
    component: () => import('@/views/icplicense/materialDetails'),
  },
  {
    path: '/icpconfirmation',
    name: 'icpconfirmation',
    component: () => import('@/views/icplicense/confirmation'),
  },
  {
    path: '/icpproductdetails',
    name: 'icpproductdetails',
    component: () => import('@/views/icplicense/productdetails'),
  },
  //////////////////////////////////////上面是icp

  //////////////////////////////////////下面是政策后台页面 --- 已上线 --- 放在/views/policymanage/的文件夹里面
  {
    path: '/',
    redirect: '/user',
  },
  {
    path: '/user',
    name: 'user',
    redirect: '/user/login',
    component: () => import('@/views/policymanage/policyuser'),
    children: [{
      path: 'login',
      name: 'login',
      component: () => import('@/views/policymanage/policyuser/login'),
    },
    {
      path: 'register',
      name: 'register',
      component: () => import('@/views/policymanage/policyuser/register'),
    },
    {
      path: 'forgetpassword',
      name: 'forgetpassword',
      component: () =>
        import('@/views/policymanage/policyuser/forgetPassword'),
    },
    ],
  },
  {
    path: '/policyadmin',
    name: 'policyadmin',
    component: () => import('@/views/policymanage/policyadmin/policyadmin.vue'),
  },
  //////////////////////////////////////上面是政策后台页面

  //////////////////////////////////////下面是阿里普通公司注册和云上公司注册 --- 已上线 --- 放在/views/fqembed/的文件夹里面
  {
    ///// 公司列表页
    path: '/companylist',
    name: 'companylist',
    component: () => import('@/views/fqembed/companylist.vue'),
  },
  {
    ///// 中转页面
    path: '/needProxy',
    name: 'needProxy',
    component: () => import('@/views/fqembed/needProxy.vue'),
  },
  //////////////////////////////////////上面是阿里普通公司注册和云上公司注册

  //////////////////////////////////////下面是企链 --- 已上线 --- 放在/views/chain/的文件夹里面
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/chain/home'),
  },
  {
    path: '/companyinformation',
    name: 'companyinformation',
    component: () => import('@/views/chain/companyinformation'),
  },

  //////////////////////////////////////上面是企链

  //////////////////////////////////////下面是启服通 --- 未上线，开发中 --- 放在/views/universal/的文件夹里面
  {
    // 商标检索
    path: '/jdbycquerytm',
    name: 'jdbycquerytm',
    component: () => import('@/views/universal/jdbycquerytm'),
  },
  {
    // 启服通 用户
    path: '/qftuser',
    name: 'qftuser',
    redirect: '/qftuser/login',
    component: () => import('@/views/universal/user'),
    children: [{
      // 登录
      path: 'login',
      name: 'qftlogin',
      component: () => import('@/views/universal/user/login'),
    },
    {
      // 注册
      path: 'register',
      name: 'qftregister',
      component: () => import('@/views/universal/user/register'),
    },
    {
      // 忘记密码
      path: 'forgetpassword',
      name: 'qftforgetpassword',
      component: () => import('@/views/universal/user/forgetPassword'),
    },
    ],
  },
  {
    // 支付页面 收银台
    path: '/cashier',
    name: 'cashier',
    component: () => import('@/views/universal/cashier'),
  },
  {
    // ---> guaranteereg
    path: '/productdetails',
    name: 'productdetails',
    component: () => import('@/views/universal/productdetails'),
  },
  {
    // 支付成功
    path: '/successfulpayment',
    name: 'successfulpayment',
    component: () => import('@/views/universal/successfulpayment'),
  },
  {
    // 下单页
    path: '/placeorder',
    name: 'placeorder',
    component: () => import('@/views/universal/placeorder'),
  },
  {
    // 商标(列表)详情
    path: '/jdbycdetailtm',
    name: 'jdbycdetailtm',
    component: () => import('@/views/universal/jdbycdetailtm'),
  },
  {
    // 订单列表 我的订单
    path: '/jdindentlist',
    name: 'jdindentlist',
    component: () => import('@/views/universal/jdindentlist'),
  },
  {
    // 订单详情
    path: '/jdindentdetail',
    name: 'jdindentdetail',
    component: () => import('@/views/universal/jdindentdetail'),
  },
  {
    // 详情页
    path: '/companydetail',
    name: 'companydetail',
    component: () => import('@/views/universal/companydetail'),
  },
  /////////
  {
    // 商标首页
    path: '/jdtrademark',
    name: 'jdtrademark',
    component: () => import('@/views/universal/jdtrademark/Jdtrademark'),
  },
  {
    // 自助商标注册
    path: '/selftmreg',
    name: 'selftmreg',
    component: () => import('@/views/universal/selftmreg/Selftmreg'),
  },
  {
    // 产品详情：专家辅助 担保注册
    path: '/guaranteereg',
    name: 'guaranteereg',
    component: () => import('@/views/universal/guaranteereg/Guaranteereg'),
  },
  {
    // 公告查询 十二期公告 首页
    path: '/bycnoticetm',
    name: 'bycnoticetm',
    component: () => import('@/views/universal/bycnoticetm/Bycnoticetm'),
  },
  {
    // 公告查询 查询页面 查询数据列表
    path: '/bycnoticeindex',
    name: 'bycnoticeindex',
    component: () => import('@/views/universal/bycnoticeindex/Bycnoticeindex'),
  },
  {
    // 公告查询 公告详情页
    path: '/bycnoticedetail',
    name: 'bycnoticedetail',
    component: () =>
      import('@/views/universal/bycnoticedetail/Bycnoticedetail'),
  },
  {
    // 用户中心 我的订单 确认订单页
    path: '/confirmorder',
    name: 'confirmorder',
    component: () => import('@/views/universal/confirmorder/confirmorder.vue'),
  },
  //////////////////////////////////////上面是启服通

  // 商标接入360 start
  {
    // 商标检索
    path: '/bycquerytm360',
    name: 'bycquerytm360',
    meta: {
      title: "商标检索"
    },
    component: () => import('@/views/brand360/jdbycquerytm'),
  },
  {
    // 启服通 用户
    path: '/qftuser360',
    name: 'qftuser360',
    redirect: '/qftuser360/login',
    component: () => import('@/views/brand360/user'),
    children: [{
      // 登录
      path: 'login',
      name: 'qftlogin360',
      component: () => import('@/views/brand360/user/login'),
    },
    {
      // 注册
      path: 'register',
      name: 'qftregister360',
      component: () => import('@/views/brand360/user/register'),
    },
    {
      // 忘记密码
      path: 'forgetpassword',
      name: 'qftforgetpassword360',
      component: () => import('@/views/brand360/user/forgetPassword'),
    },
    ],
  },
  {
    // 支付页面 收银台
    path: '/cashier360',
    name: 'cashier360',
    component: () => import('@/views/brand360/cashier'),
  },
  {
    // ---> guaranteereg
    path: '/productdetails360',
    name: 'productdetails360',
    component: () => import('@/views/brand360/productdetails'),
  },
  {
    // 支付成功
    path: '/successfulpayment360',
    name: 'successfulpayment360',
    component: () => import('@/views/brand360/successfulpayment'),
  },
  {
    // 下单页
    path: '/placeorder360',
    name: 'placeorder360',
    component: () => import('@/views/brand360/placeorder'),
  },
  {
    // 商标(列表)详情
    path: '/bycdetailtm360',
    name: 'bycdetailtm360',
    meta: {
      title: "商标详情"
    },
    component: () => import('@/views/brand360/jdbycdetailtm'),
  },
  {
    // 订单列表 我的订单
    path: '/indentlist360',
    name: 'indentlist360',
    component: () => import('@/views/brand360/jdindentlist'),
  },
  {
    // 订单详情
    path: '/indentdetail360',
    name: 'indentdetail360',
    component: () => import('@/views/brand360/jdindentdetail'),
  },
  {
    // 详情页
    path: '/companydetail360',
    name: 'companydetail360',
    component: () => import('@/views/brand360/companydetail'),
  },
  {
    // 商标首页
    path: '/trademark360',
    name: 'trademark360',
    meta: {
      title: '商标首页'
    },
    component: () => import('@/views/brand360/jdtrademark/Jdtrademark'),
  },
  {
    // 自助商标注册
    path: '/selftmreg360',
    name: 'selftmreg360',
    meta: {
      title: '自助商标注册'
    },
    component: () => import('@/views/brand360/selftmreg/Selftmreg'),
  },
  {
    // 产品详情：专家辅助 担保注册
    path: '/guaranteereg360',
    name: 'guaranteereg360',
    component: () => import('@/views/brand360/guaranteereg/Guaranteereg'),
  },
  {
    // 公告查询 十二期公告 首页
    path: '/bycnoticetm360',
    name: 'bycnoticetm360',
    component: () => import('@/views/brand360/bycnoticetm/Bycnoticetm'),
  },
  {
    // 公告查询 查询页面 查询数据列表
    path: '/bycnoticeindex360',
    name: 'bycnoticeindex360',
    component: () => import('@/views/brand360/bycnoticeindex/Bycnoticeindex'),
  },
  {
    // 公告查询 公告详情页
    path: '/bycnoticedetail360',
    name: 'bycnoticedetail360',
    component: () =>
      import('@/views/brand360/bycnoticedetail/Bycnoticedetail'),
  },
  {
    // 用户中心 我的订单 确认订单页
    path: '/confirmorder360',
    name: 'confirmorder360',
    component: () => import('@/views/brand360/confirmorder/confirmorder.vue'),
  },
  {
    //增值电信
    path: '/zzdx360',
    name: 'zzdx360',
    meta: {
      title: '增值电信'
    },
    component: () => import('@/views/brand360/zzdx'),
  },
  // 商标接入360 end

  ////////////////商标复审start///////
  {
    path: '/brandReview',
    name: 'brandReview',
    redirect: '/brandReview/selfHelp',
    component: () => import('@/views/brandReview/index'),
    children: [
      // 自助商标驳回复审
      {
        path: 'selfHelp',
        name: 'selfHelp',
        redirect: '/brandReview/selfHelp/rejectInformation',
        component: () => import('@/views/brandReview/selfHelp/index'),
        children: [{
          path: 'rejectInformation',
          name: 'rejectInformation',
          component: () => import('@/views/brandReview/selfHelp/child/rejectInformation'),
          meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          }
        },
        {
          path: 'applicantInformation',
          name: 'applicantInformation',
          component: () => import('@/views/brandReview/selfHelp/child/applicantInformation'),
          meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          }
        },
        {
          path: 'agentInformation',
          name: 'agentInformation',
          component: () => import('@/views/brandReview/selfHelp/child/agentInformation'),
          meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          }
        },
        {
          path: 'payResult',
          name: 'payResult',
          component: () => import('@/views/brandReview/selfHelp/child/payResult'),
          meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          }
        }
        ]
      },
      //商标驳回复审专业版
      {
        path: 'professional',
        name: 'professional',
        redirect: '/brandReview/professional/PFrejectInformation',
        component: () => import('@/views/brandReview/professional/index'),
        children: [{
          path: 'PFrejectInformation',
          name: 'PFrejectInformation',
          component: () => import('@/views/brandReview/professional/child/PFrejectInformation'),
          meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          }
        },
        {
          path: 'PFapplicantInformation',
          name: 'PFapplicantInformation',
          component: () => import('@/views/brandReview/professional/child/PFapplicantInformation'),
          meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          }
        },
        {
          path: 'PFagentInformation',
          name: 'PFagentInformation',
          component: () => import('@/views/brandReview/professional/child/PFagentInformation'),
          meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          }
        },
        {
          path: 'PFpayResult',
          name: 'PFpayResult',
          component: () => import('@/views/brandReview/professional/child/PFpayResult'),
          meta: {
            keepAlive: true, //此组件需要被缓存
            isBack: false, //用于判断上一个页面是哪个
          }
        }
        ]
      },
      // 驳回复审控制台
      {
        path: 'brandController',
        name: 'brandController',
        redirect: '/brandReview/brandController/archivesRecheck',
        component: () => import('@/views/brandReview/brandController/controllerBase'),
        children: [
          // 驳回复审
          {
            path: 'archivesRecheck',
            name: 'archivesRecheck',
            component: () => import('@/views/brandReview/brandController/archivesRecheck/archivesRecheck'),
            meta: {
              keepAlive: true, //此组件需要被缓存
              isBack: false, //用于判断上一个页面是哪个
            }
          },
          //自助支付
          {
            path: 'detailpay',
            name: 'detailpay',
            component: () => import('@/views/brandReview/brandController/payManage/detailpay'),
          },
          //专业支付
          {
            path: 'spdetail',
            name: 'spdetail',
            component: () => import('@/views/brandReview/brandController/payManage/spdetail'),
          },
          // 官文管理
          {
            path: 'officialDocManage',
            name: 'officialDocManage',
            component: () => import('@/views/brandReview/brandController/officialDocManage/officialDocManage')
          },
          // 我的订单
          {
            path: 'myOrder',
            name: 'myOrder',
            component: () => import('@/views/brandReview/brandController/myOrder/myOrder'),
            meta: {
              keepAlive: true, //此组件需要被缓存
              isBack: false, //用于判断上一个页面是哪个
            }
          },
          // 我的订单详情
          {
            path: 'orderDetail',
            name: 'orderDetail',
            component: () => import('@/views/brandReview/brandController/orderDetail/orderDetail')
          }
        ]
      },
      // 收银台
      {
        path: 'cashier',
        name: 'cashier',
        component: () => import('@/views/brandReview/cashier/index')
      },
      // 首页
      {
        path: 'brandHome',
        name: 'brandHome',
        component: () => import('@/views/brandReview/home/home'),
      },
    ],
  },
  ////////////////商标复审end///////


  ////////////////资质诊断  start///////////////////
  {
    path: '/diagnose',
    name: 'diagnose',
    redirect: '/diagnose/zzzduser/login',
    component: () => import('@/views/zzzd/index'),
    children: [
      //电商诊断
      {
        path: 'ECommerce',
        name: 'ECommerce',
        redirect: '/ECommerce/settledType',
        component: () => import('@/views/zzzd/ECommerce/ecIndex'),
        children: [{
          // 资质要求
          path: 'settledType',
          name: 'settledType',
          component: () => import('@/views/zzzd/ECommerce/zzzd_settledType/zzzd_settledType.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 基础评估
          path: 'baseEvaluate',
          name: 'baseEvaluate',
          component: () => import('@/views/zzzd/ECommerce/zzzd_baseEvaluate/zzzd_baseEvaluate.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 智能诊断
          path: 'smartDiagnose',
          name: 'smartDiagnose',
          component: () => import('@/views/zzzd/ECommerce/zzzd_smartDiagnose/zzzd_smartDiagnose.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 评估结果
          path: 'evaluateResult',
          name: 'evaluateResult',
          component: () => import('@/views/zzzd/ECommerce/zzzd_evaluateResult/zzzd_evaluateResult.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 提交成功页面
          path: 'submitPage',
          name: 'submitPage',
          component: () => import('@/views/zzzd/ECommerce/zzzd_submitPage/zzzd_submitPage.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 产品详情页面
          path: 'zzzdProductDetail',
          name: 'zzzdProductDetail',
          component: () => import('@/views/zzzd/ECommerce/zzzd_productDetail/zzzd_productDetail.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 收银台
          path: 'zzzdCashier',
          name: 'zzzdCashier',
          meta: {
            title: '资质诊断'
          },
          component: () => import('../views/zzzd/ECommerce/zzzd_cashier/index.vue'),
        },
        ],
      },
      //直播诊断
      {
        path: 'Liveplatform',
        name: 'Liveplatform',
        redirect: '/Liveplatform/settledType',
        component: () => import('@/views/zzzd/Liveplatform/ecIndex'),
        children: [{
          // 资质要求
          path: 'settledType',
          name: 'LiveplatformsettledType',
          component: () => import('@/views/zzzd/Liveplatform/zzzd_settledType/zzzd_settledType.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 基础评估
          path: 'baseEvaluate',
          name: 'LiveplatformbaseEvaluate',
          component: () => import('@/views/zzzd/Liveplatform/zzzd_baseEvaluate/zzzd_baseEvaluate.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 评估结果
          path: 'evaluateResult',
          name: 'LiveplatformevaluateResult',
          // component: () => import('@/views/zzzd/Liveplatform/zzzd_evaluateResult/zzzd_evaluateResult.vue'),
          component: () => import('@/views/zzzd/ECommerce/zzzd_evaluateResult/zzzd_evaluateResult.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 提交成功页面
          path: 'submitPage',
          name: 'LiveplatformsubmitPage',
          // component: () => import('@/views/zzzd/Liveplatform/zzzd_submitPage/zzzd_submitPage.vue'),
          component: () => import('@/views/zzzd/ECommerce/zzzd_submitPage/zzzd_submitPage.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 产品详情页面
          path: 'zzzdProductDetail',
          name: 'LiveplatformzzzdProductDetail',
          // component: () => import('@/views/zzzd/Liveplatform/zzzd_productDetail/zzzd_productDetail.vue'),
          component: () => import('@/views/zzzd/ECommerce/zzzd_productDetail/zzzd_productDetail.vue'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 收银台
          path: 'zzzdCashier',
          name: 'LiveplatformzzzdCashier',
          meta: {
            title: '资质诊断'
          },
          component: () => import('../views/zzzd/Liveplatform/zzzd_cashier/index.vue'),
        },
        {
          // 
          path: 'steploading',
          name: 'Liveplatformsteploading',
          meta: {
            title: '资质诊断'
          },
          // component: () => import('../views/zzzd/Liveplatform/zzzd_loading/zzzd_loading.vue'),
          component: () => import('@/views/zzzd/ECommerce/zzzd_smartDiagnose/zzzd_smartDiagnose.vue'),
        },
        ],
      },
      // 用户登录
      {
        // 资质诊断 用户
        path: 'zzzduser',
        name: 'zzzduser',
        redirect: '/zzzduser/login',
        component: () => import('@/views/zzzd/zzzd_user'),
        children: [{
          // 登录
          path: 'login',
          name: 'zzzdlogin',
          component: () => import('@/views/zzzd/zzzd_user/login'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 注册
          path: 'register',
          name: 'zzzdregister',
          component: () => import('@/views/zzzd/zzzd_user/register'),
          meta: {
            title: '资质诊断'
          }
        },
        {
          // 忘记密码
          path: 'forgetpassword',
          name: 'zzzdforgetpassword',
          component: () => import('@/views/zzzd/zzzd_user/forgetPassword'),
          meta: {
            title: '资质诊断'
          }
        },
        ],
      },
      // 首页
      {
        // 产品详情页面
        path: 'zzzdHome',
        name: 'zzzdHome',
        component: () => import('@/views/zzzd/home/home.vue'),
        meta: {
          title: '资质诊断'
        }
      },
      {
        // 评估结果（通过，未通过）
        path: 'result',
        name: 'zzzdResult',
        component: () => import('@/views/zzzd/personal/zzzd_result/zzzd_result.vue'),
        meta: {
          title: '资质诊断'
        }
      },
    ]
  },
  {
    path: '/diagnose/personal',
    redirect: '/diagnose/personal/myDiagnosis',
    component: () => import('@/views/zzzd/personal/index.vue'),
    children: [
      {
        // 我的诊断
        path: 'myDiagnosis',
        name: 'myDiagnosis',
        component: () => import('@/views/zzzd/personal/zzzd_myDiagnosis/zzzd_myDiagnosis.vue'),
        meta: {
          title: '资质诊断'
        }
      },
      {
        // 诊断中
        path: 'artificialDiagnose',
        name: 'artificialDiagnose',
        component: () => import('@/views/zzzd/personal/zzzd_artificialDiagnose/zzzd_artificialDiagnose.vue'),
        meta: {
          title: '资质诊断'
        }
      },
      {
        // 评估结果（通过，未通过）
        path: 'result',
        name: 'result',
        component: () => import('@/views/zzzd/personal/zzzd_result/zzzd_result.vue'),
        meta: {
          title: '资质诊断'
        }
      },
      {
        // 企业信息
        path: 'companyInfo',
        name: 'companyInfo',
        component: () => import('@/views/zzzd/personal/zzzd_companyInfo/zzzd_companyInfo.vue'),
        meta: {
          title: '资质诊断'
        }
      },
      {
        // 需求详情
        path: 'demandDetail',
        name: 'demandDetail',
        component: () => import('@/views/zzzd/personal/demand/index.vue'),
        meta: {
          title: '资质诊断'
        }
      },
      {
        // 需求信息
        path: 'demandInfo',
        name: 'demandInfo',
        component: () => import('@/views/zzzd/personal/zzzd_demandList/zzzd_demandList.vue'),
        meta: {
          title: '资质诊断'
        }
      },
    ]
  },
  ////////////////资质诊断  end///////////////////

  //资质诊断后台管理  start
  {
    // 
    path: '/zzzdadmin',
    name: 'zzzdadmin',
    redirect: '/zzzdadmin/index',
    component: () => import('@/views/zzzdadmin/index.vue'),
    children: [{
      // 待处理诊断
      path: 'index',
      name: 'pendingindex',
      meta: {
        title: '资质诊断'
      },
      component: () => import('@/views/zzzdadmin/pending'),
    },
    {
      // 全部诊断申请
      path: 'allapply',
      name: 'allapply',
      meta: {
        title: '资质诊断'
      },
      component: () => import('@/views/zzzdadmin/allapply'),
    },
    {
      // 全部诊断申请详情
      path: 'allapplydetails',
      name: 'allapplydetails',
      meta: {
        title: '资质诊断'
      },
      component: () => import('@/views/zzzdadmin/allapply/details.vue'),
    },
    {
      // 历史诊断
      path: 'history',
      name: 'history',
      meta: {
        title: '资质诊断'
      },
      component: () => import('@/views/zzzdadmin/history'),
    },
    {
      // 需求管理
      path: 'demand',
      name: 'zzdemand',
      meta: {
        title: '资质诊断'
      },
      component: () => import('@/views/zzzdadmin/demand'),
    },
    {
      // 需求详情
      path: 'demandDetails',
      name: 'demandDetails',
      meta: {
        title: '资质诊断'
      },
      component: () => import('@/views/zzzdadmin/demand/details.vue'),
    },
    ]
  },
  {
    // 登录
    path: '/zzzdlogin',
    name: 'zzzd_login',
    component: () => import('@/views/zzzdadmin/login/index.vue'),
    meta: {
      title: '资质诊断'
    }
  },
  //资质诊断后台管理  end

  ////////////////////食品经营许可证查询  start////////////////

  // 首页
  {
    path: '/foodLicense/home',
    name: 'home',
    component: () => import('@/views/foodLicense/home/home.vue'),
  },
  {
    path: '/foodLicense/licenseInfo',
    name: 'licenseInfo',
    component: () => import('@/views/foodLicense/licenseInfo/index.vue'),
  },
  {
    // 食品经营许可证详情
    path: '/foodLicense/licenseDetail',
    name: 'licenseDetail',
    component: () => import('@/views/foodLicense/licenseDetail/licenseDetail.vue'),
  }
  ////////////////////食品经营许可证查询  end////////////////
];
const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return {
        x: 0,
        y: 0
      };
    }
  },
});

// router.beforeEach((to, from, next) => {
//   let userpin = getCookie("userpin");
//   if (
//     to.path == "/qftuser/login" ||
//     to.path == "/qftuser/register" ||
//     to.path == "/qftuser/forgetPassword" ||
//     to.path == "/jdtrademark"
//   ) {
//     next();
//   } else {
//     if (userpin == "" || userpin == null) {
//       next("/qftuser/login");
//     } else {
//       next();
//     }
//   }
// });

router.beforeEach((to, from, next) => {
  to.meta.title ? document.title = to.meta.title : document.title = '政策中心'
  next()
});

export default router;